import { cn } from '../../utils/cn';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

const styledCardStyles = cva('overflow-hidden', {
  variants: {
    bg: {
      default: 'bg-gray-900', //'bg-gray-90',
      highlight: 'bg-success-light',
      lightBlue: 'bg-sui/10',
      white: 'bg-white',
      'white/80': 'bg-white/5',
      'hero-default': 'bg-hero',
    },
    height: {
      full: 'h-full',
    },
    width: {
      full: 'w-full',
    },
    rounded: {
      lg: 'rounded-lg',
      xl: 'rounded-xl',
      '2xl': 'rounded-2xl',
    },
    spacing: {
      none: '',
      sm: 'px-5 py-4',
      md: 'p-5',
      lg: 'p-6',
      lgGraph: 'p-6 pb-4',
    },
    border: {
      gray45: 'border border-gray-45',
      steel: 'border border-steel',
    },
    shadow: {
      true: 'shadow-md',
    },
    growOnHover: {
      true: 'hover:scale-101 ease-in-out duration-200',
    },
  },
  defaultVariants: {
    bg: 'default',
    spacing: 'md',
    rounded: 'xl',
  },
});

export interface StyledCardProps
  extends ComponentPropsWithoutRef<'div'>,
    VariantProps<typeof styledCardStyles> {
  children?: ReactNode;
}

export function StyledCard({
  className,
                       spacing,
                       rounded,
                       bg,
                       border,
                       shadow,
                       children,
                       height,
                       width,
                       growOnHover,
                     }: StyledCardProps) {
  return (
    <div
      className={cn(styledCardStyles({
        spacing,
        rounded,
        bg,
        border,
        shadow,
        height,
        width,
        growOnHover,
        className
      }))}
    >
      {children}
    </div>
  );
}